import { Typography, useTheme } from "@mui/material";
import CButton from "components/CButton";
import CDialog from "components/CDialog";
import useTracker from "components/CTracker/useTrackerContext";
import { useState } from "react";
import API from "utils/API";

export type TexasAppraisalDialogProps = {
  open: boolean;
  onAccept: () => void;
};

const TexasAppraisalDialog: React.FC<TexasAppraisalDialogProps> = ({
  open,
  onAccept,
}) => {
  const theme = useTheme();
  const { loan } = useTracker();
  let amountAbove350k = false;
  if (loan) {
    amountAbove350k = loan?.initialOffer?.amount > 350000;
  }
  const firstPartOfMessage = amountAbove350k
    ? "Loan amount is above $350,000,"
    : "There is not enough recent sales data to support an Automated Valuation Model (AVM),";

  const [timeout, setLilTimeout] = useState(false);
  setTimeout(() => {
    setLilTimeout(true);
  }, 1500);
  const handleAccept = async (appraisalType: string) => {
    await API.post({
      url: `/save-to-loan/set-appraisal-type`,
      data: {
        loanId: loan?.id,
        appraisalType,
      },
    });
    onAccept();
  };
  const appraisalFees = loan?.initialOffer.appraisalFees;

  return (
    <CDialog
      open={open}
      maxWidth="md"
      icon="warning"
      title="We need to make an appraisal"
    >
      <Typography fontWeight={600} fontSize={{ md: "1.1rem" }} marginBottom={3}>
        {firstPartOfMessage} so we need to do an Appraisal. There are two
        options for you to consider:
      </Typography>
      <div>
        <Typography
          fontWeight={600}
          fontSize={{ md: "1rem" }}
          marginBottom={2}
          color={theme.palette.text.secondary}
        >
          ADV: This process will send you a link with instructions for you to
          take some photos of your property with your phone. The cost is $160.
          Once you complete the photos, the review process takes a few days.
        </Typography>
        <CButton
          disabled={!timeout}
          fullWidth
          variant="contained"
          onClick={() => handleAccept("ADV")}
          sx={{
            textTransform: "inherit",
            fontSize: 18,
            fontWeight: 500,
            marginBottom: 3,
          }}
        >
          Select ADV
        </CButton>
      </div>
      <div>
        <Typography
          fontWeight={600}
          fontSize={{ md: "1rem" }}
          marginBottom={2}
          color={theme.palette.text.secondary}
        >
          Appraisal: A certified appraiser will schedule a visit to your
          property and complete the appraisal. The cost is $
          {Number(appraisalFees).toLocaleString("en-US")} and typically can be
          completed within a few days.
        </Typography>
        <CButton
          fullWidth
          variant="contained"
          onClick={() => handleAccept("Appraisal")}
          sx={{ textTransform: "inherit", fontSize: 18, fontWeight: 500 }}
        >
          Select Appraisal
        </CButton>
      </div>
    </CDialog>
  );
};

export default TexasAppraisalDialog;
